<template>
  <div class="customer-feedback default-card">
    <div class="image flex">
      <img
        :src="getImageUrl(imageSrc)"
        :alt="altText"
      >
      <div>
        <div class="feedback">
          <span class="main-feedback">
            {{ testimonial }}
          </span>
        </div>
        <p>
          <b>{{ name }}</b>
          <i>{{ role }}</i>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Testimonial",
  props: {
    imageSrc: { type: String, required: true },
    altText: { type: String, required: false, default: "Alt image" },
    testimonial: { type: String, required: true },
    name: { type: String, required: true },
    role: { type: String, required: true },
  },
  methods: {
    getImageUrl(name) {
      return require(`@/assets/img/${name}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-feedback .image {
  img {
    min-width: 200px;
    min-height: 200px;
  }
  p i {
    min-height: 0;
  }
}

.default-card {
  box-shadow: none;
  background: #f7f4ff;
}
.customer-feedback {
  width: auto;
  min-height: 0;
}

.customer-feedback .feedback {
  padding: 0 0 10px 20px;
  .main-feedback {
    margin: 0;
    font-weight: normal;
    font-size: 15px;
  }
}

@media (max-width: 767px) {
  .flex {
    display: block;
  }

  .customer-feedback .feedback {
    padding: 20px 0 0;
  }
  .customer-feedback .image {
    img {
      min-width: 150px;
      min-height: 150px;
    }
    p {
      padding: 20px 0 0;
    }
  }
}
</style>
